import withWidth from '@material-ui/core/withWidth'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import GoogleMapReact from 'google-map-react'
import storyMarker from '../../../../../assets/images/story-marker.png'
import useStyles from './styles'

const createMapOptions = ({ fullscreen }) => () => {
  return {
    zoomControl: false,
    fullscreenControl: fullscreen || false,
    clickableIcons: false,
  }
}

const MapComponent = ({
  fullscreen,
  apiKey,
  coords,
  width,
  constituency,
  stories,
  onClickStory,
}) => {
  const classes = useStyles({ width })

  const LocationMarker = () => (
    <div>
      <div className={classes.locationMarker}>YOUR LOCATION</div>
      <div className={classes.locationArrow} />
      <FiberManualRecordIcon
        color="secondary"
        fontSize={'small'}
        className={classes.locationDot}
      />
    </div>
  )

  const StoryMarker = ({ id }) => (
    <div onClick={() => onClickStory(id)}>
      <img src={storyMarker} alt="story map marker" className={classes.storyMarker} />
    </div>
  )

  const handleApiLoaded = (map, maps) => {
    if (!!constituency) {
      new maps.KmlLayer(constituency.kml_url, {
        suppressInfoWindows: true,
        preserveViewport: false,
        map: map,
      })
    } else if (!!stories) {
      const latLngBounds = new maps.LatLngBounds()
      const latLng = stories.map((item) => new maps.LatLng(item.latitude, item.longitude))
      for (let i = 0; i < latLng.length; i++) {
        latLngBounds.extend(latLng[i])
      }
      map.fitBounds(latLngBounds)
    }
  }

  if (!apiKey) return null

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: apiKey }}
      defaultCenter={{ lat: 51.4769, lng: 0.0005 }} // Greenwich observatory
      defaultZoom={15}
      center={coords}
      options={createMapOptions({ fullscreen })}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
    >
      {!!stories ? (
        stories.map((item) => (
          <StoryMarker
            key={item.id}
            id={item.id}
            lat={item.latitude}
            lng={item.longitude}
          />
        ))
      ) : (
        <LocationMarker {...coords} />
      )}
    </GoogleMapReact>
  )
}

export default withWidth()(MapComponent)
